<script setup>
import { useRoute } from 'vue-router'
import ToastContainer from './components/ToastContainer.vue'
import { useCustomToast } from './composables/useCustomToast'
import { ElNotification } from 'element-plus'

const route = useRoute()
const { setToastContainer } = useCustomToast()

// Setup Reverb listener for export completion
const currentUser = JSON.parse(localStorage.getItem('auth_user') || '{}');
if (currentUser && currentUser.id) {
  window.Echo.private(`user.${currentUser.id}`)
    .listen('SearchExportCompleted', (e) => {
      console.log('🎉 Export completed:', e);

      // Show success notification
      ElNotification.success({
        title: 'Export Ready!',
        message: e.message,
        duration: 5000,
        showClose: true
      });

      // Auto-download the file
      const link = document.createElement('a');
      link.href = e.download_url;
      link.download = e.file_name;
      link.click();

      // Reset export status
      exportStatus.value = 'completed';

      // Auto-hide success message after download
      setTimeout(() => {
        exportStatus.value = null;
      }, 3000);
    });
}

</script>

<template>
  <router-view></router-view>
  <ToastContainer ref="toastContainer" position="bottom-left" />
</template>
